import React from 'react';
import { IoSparkles } from 'react-icons/io5';
import { MdArrowForward } from 'react-icons/md';
import './AIAgentBanner.css';

export default function AIAgentBanner() {
    return (
        <div className="ai-agent-banner-container">
            <div className="ai-agent-banner-content">
                <IoSparkles size={24} className="ai-agent-banner-icon" />
                <span className="ai-agent-banner-text">
                    NEW: AI Agents are here - 40% more leads from the same traffic →
                </span>
            </div>
        </div>
    );
}
